import { createFileRoute } from '@tanstack/react-router'
import { Billing } from '../../../../../ui'

export const Route = createFileRoute(
	'/_auth/company/$companyId/settings/billing',
)({
	component: RouteComponent,
})

function RouteComponent() {
	return <Billing />
}
